import Spinner from "../../../../components/Spinner.jsx";
import {useTranslation} from "react-i18next";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import FacebookLoginButton from "../../../../utils/brands/FacebookLoginButton.jsx";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import Select from "react-select";
import Button from "../../../../components/Button.jsx";
import useDownloadState from "../../../../api/utilities/useDownloadState.js";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import {IntegrationActions, IntegrationSection, OAuthConnectionStatus} from "../IntegrationDetailUi.jsx";

export default function MetaIntegrationForm({project, projectIntegration, refreshOAuthResources}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let adAccountDefaultValues = [];
    let adAccountOptions = [];


    for (let adAccount of projectIntegration?.metaIntegrationAdAccounts ?? []) {
        adAccountOptions.push({
            value: adAccount.accountId,
            label: '[' + adAccount.accountId + '] ' + adAccount.name
        });

        if (adAccount.enabled) {
            adAccountDefaultValues.push({
                value: adAccount.accountId,
                label: '[' + adAccount.accountId + '] ' + adAccount.name
            });
        }
    }

    let [selectedAdAccounts, setSelectedAdAccounts] = useState(adAccountDefaultValues);

    const {context, getAuthorityConfiguration, resetCurrentUserProjects} = useContext(GlobalContext);

    let redirectToLogin = () => {
        let oAuthUrl = new URL(import.meta.env.VITE_AUTHORITY_URL);
        oAuthUrl.pathname = '/api/v1/project/integrations/meta';

        let query = new URLSearchParams({
            authorization: context.currentIdentity?.token,
            projectId: project.id,
        });

        if (projectIntegration?.id) {
            query.set('integrationId', projectIntegration.id);
        }

        oAuthUrl.search = query.toString();

        window.location.href = oAuthUrl.toString();
    };

    useEffect(() => {
        if (!projectIntegration) {
            setTimeout(
                () => redirectToLogin(),
                100,
            )
        }
    }, []);

    let [state, setDownloading] = useDownloadState();

    let saveAdAccounts = () => {
        let adAccountIds = [];

        for (let adAccountOption of selectedAdAccounts) {
            adAccountIds.push(adAccountOption.value);
        }

        setDownloading(true);
        new ProjectIntegrationsApi(getAuthorityConfiguration())
            .chooseMetaAdAccounts({
                projectId: project.id,
                integrationId: projectIntegration.id,
                requestBody: adAccountIds
            })
            .then(() => {
                resetCurrentUserProjects();
            })
            .finally(() => setDownloading(false))
    };

    const refreshAdAccounts = () => {
        setDownloading(true);
        Promise.resolve(refreshOAuthResources())
            .finally(() => setDownloading(false));
    };
    if (!projectIntegration) {
        return (
            <div>
                <Spinner size={'spinner-large'} className={'mx-auto'}/>
                <p className={'text-center mt-4'}>{t('redirecting')}...</p>
            </div>
        );
    }

    const reconnectRequired = !projectIntegration.authorizationSuccessful || (projectIntegration.errors ?? []).length > 0;

    const connectButton = <FacebookLoginButton
        className={'integration-connect-button'}
        configurationId={import.meta.env.VITE_META_CONNECT_CONFIGURATION_ID}
        onClick={() => redirectToLogin()}
        config={{
            response_type: 'code',
            override_default_response_type: true,
            scope: 'ads_read,business_management'
        }}
    >
        {reconnectRequired ? 'Připojit' : 'Obnovit připojení'}
    </FacebookLoginButton>;

    return (<div className={'flex flex-col gap-5'}>
        <IntegrationSection
            title={'Připojení k Meta'}
            description={'OAuth připojení slouží k bezpečnému načtení dostupných reklamních účtů. Obnovení připojení nezmění uložený výběr účtů.'}
        >
            <OAuthConnectionStatus connected={!reconnectRequired} action={connectButton}/>
        </IntegrationSection>

        <IntegrationSection
            title={t('project.ad-accounts')}
            description={'Vyberte účty, které má Datixo pravidelně stahovat a zahrnout do reportingu.'}
        >
            <Select
                defaultValue={adAccountDefaultValues}
                isMulti
                name="colors"
                options={adAccountOptions}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder={null}
                noOptionsMessage={() => t('project.integration-no-options')}
                onChange={setSelectedAdAccounts}
            />
            <div className={'mt-5'}>
                <IntegrationActions hint={<Button variant={'outline-primary'} className={'integration-secondary-button'} onClick={refreshAdAccounts}>Aktualizovat seznam</Button>}>
                    <Button className={'button-primary'} onClick={() => saveAdAccounts()}>
                        Uložit výběr
                    </Button>
                </IntegrationActions>
            </div>
        </IntegrationSection>

    </div>);
}
